import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { Invitation } from '../../../../models/Invitation';
import * as invitationsActions from './invitations.actions';
import { IInvitationsState } from './invitations.state';

export const adapter: EntityAdapter<Invitation> = createEntityAdapter<Invitation>({
	sortComparer: (a, b) => +b.created - +a.created,
});

export const invitationsInitialStates: IInvitationsState = adapter.getInitialState({
	loading: false,
	loaded: false,
});

export const invitationsReducer = createReducer(
	invitationsInitialStates,
	on(invitationsActions.getInvitations, (state) => ({ ...state, loading: true, loaded: false })),
	on(invitationsActions.getInvitationsSuccess, (state, { invitations }) => {
		return adapter.setAll(invitations, { ...state, loading: false, loaded: true });
	}),
	on(invitationsActions.addInvitation, (state, { invitation }) => {
		return adapter.addOne(invitation, state);
	}),
	on(invitationsActions.updateInvitation, (state, { invitation }) => {
		return adapter.upsertOne(invitation, state);
	}),
	on(invitationsActions.removeInvitation, (state, { id }) => {
		return adapter.removeOne(id, state);
	})
);
